import { render, staticRenderFns } from "./AddEmployeeSalary.vue?vue&type=template&id=fec9d6a4&scoped=true&"
import script from "./AddEmployeeSalary.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeSalary.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployeeSalary.vue?vue&type=style&index=0&id=fec9d6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec9d6a4",
  null
  
)

export default component.exports